// OIDC client identity
export const OIDC_CLIENT_ID = 'issue_manager';
export const OIDC_ACCESS_TOKEN_SCOPE = 'issues.admin';

export const OIDC_OWNER_SPA_SUBDOMAIN = 'issuemanager';

// CloudFront paths
export const OIDC_AUTH_START_PATH = '/auth/start';
export const OIDC_CALLBACK_PATH = '/auth/callback';
export const OIDC_JWKS_PATH = '/.well-known/jwks.json';
export const OIDC_FRONTCHANNEL_LOGOUT_PATH = '/frontchannel-logout.html';
export const OIDC_USERINFO_PATH = '/apis/oidc/userinfo';
export const ISSUE_MANAGER_API_PATH = '/apis/issue-manager';

// Meta tags for SPA client
export const OIDC_META_TAG_ENABLED = 'oidc-enabled';
export const OIDC_META_TAG_RESOURCE_INDICATOR = 'oidc-resource-indicator';
export const OIDC_META_TAG_API_PROXY_PATH = 'oidc-api-proxy-path';

// Cookies
export const OIDC_ACCESS_TOKEN_COOKIE_NAME = 'issue_manager_api_access_token';
export const OIDC_USERINFO_COOKIE_NAME = 'oidc_access_token';

// Tenant detection
export const OIDC_TENANT_QUERY_PARAM_NAME = 'org_subdomain';
// See TenantDetectionStrategy.subdomain in
// @diligentcorp/library-cdk-oidc-client-cloudfront-sidecar.
export const OIDC_TENANT_SUBDOMAIN_LEVEL = 4;
